export const SemanticUiColorsEnum = {
  RED: 'red',
  ORANGE: 'orange',
  YELLOW: 'yellow',
  OLIVE: 'olive',
  GREEN: 'green',
  TEAL: 'teal',
  BLUE: 'blue',
  VIOLET: 'violet',
  PURPLE: 'purple',
  PINK: 'pink',
  BROWN: 'brown',
  GREY: 'grey',
  BLACK: 'black',
};

export const SemanticUiColorOptions = [
  { key: SemanticUiColorsEnum.RED, value: 'red', description: 'Red' },
  { key: SemanticUiColorsEnum.ORANGE, value: 'orange', description: 'Orange' },
  { key: SemanticUiColorsEnum.YELLOW, value: 'yellow', description: 'Yellow' },
  { key: SemanticUiColorsEnum.OLIVE, value: 'olive', description: 'Olive' },
  { key: SemanticUiColorsEnum.GREEN, value: 'green', description: 'Green' },
  { key: SemanticUiColorsEnum.TEAL, value: 'teal', description: 'Teal' },
  { key: SemanticUiColorsEnum.BLUE, value: 'blue', description: 'Blue' },
  { key: SemanticUiColorsEnum.VIOLET, value: 'violet', description: 'Violet' },
  { key: SemanticUiColorsEnum.PURPLE, value: 'purple', description: 'Purple' },
  { key: SemanticUiColorsEnum.PINK, value: 'pink', description: 'Pink' },
  { key: SemanticUiColorsEnum.BROWN, value: 'brown', description: 'Brown' },
  { key: SemanticUiColorsEnum.GREY, value: 'grey', description: 'Grey' },
  { key: SemanticUiColorsEnum.BLACK, value: 'black', description: 'Black' },
];



// WEBPACK FOOTER //
// ./src/common/Constants/SemanticUiColors.js